<template>
  <div>
    <template v-for="item in agent">
      <div v-show="item.value > 0" :key="item.label" class="cell">
        <span class="flex align-center">
          {{ item.label }}
          <van-icon v-if="item.info" name="info" class="color-fc3159 ml-5" @click="$dialog.alert({ message: item.info })"/>
        </span>
        <span>{{ item.value }}位</span>
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'AgentInfo',
    props: {
      agent: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<style lang="scss" scoped>
.cell{
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  font-size: 14px;
  line-height: 35px;
  &:nth-of-type(2n){
    background-color: #f3f4f6;
  }
  .color-fc3159{
    color: #fc3159;
  }
}
</style>
